import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { matchPath } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import routes from 'app/fuse-configs/routesConfig'

if (
  ['dev', 'qa', 'prod'].includes(process.env.REACT_APP_ENV) &&
  process.env.REACT_APP_SENTRY_DSN
) {
  const history = createBrowserHistory()
  Sentry.init({
    environment: process.env.REACT_APP_ENV,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
        routes,
        matchPath,
      }),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 0.1,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\//, /^https:\/\/*\.messagespring\.com/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.5,
  })
}
